import * as React from 'react'
import type { RowItemProps } from './Row.types'
import { cn } from '@core/utils'

const RowItem: React.FC<RowItemProps> = ({
    title,
    LeftComponent,
    RightComponent,
    className,
    ...props
}) => {
    return (
        <div
            className={cn(
                'flex items-center gap-3 rounded-[13px] bg-semantic-background-primary px-4 py-3',
                props.onClick && 'cursor-pointer',
                className,
            )}
            {...props}>
            {LeftComponent}
            <span className="min-w-0 flex-1 truncate text-left text-body-md-r text-semantic-content-ink">
                {title}
            </span>
            {RightComponent}
        </div>
    )
}

export default RowItem
